export type PersistAlertType = 'success' | 'error' | 'info' | 'warning' | '';

export class CmpPersistAlertObject {
    public type: PersistAlertType = '';
    public message: string = '';
    public title: string = '';
    public isOpen: boolean = true;
    public cssClass: string = '';
    public iconCssClass: string = '';

    public typeCallback: (() => PersistAlertType) | undefined = undefined;
    public messageCallback: (() => string) | undefined = undefined;
    public titleCallback: (() => string) | undefined = undefined;
    public isOpenCallback: (() => boolean) | undefined = undefined;

    public static create(
        type: PersistAlertType | (() => PersistAlertType),
        title: string | (() => string),
        message: string | (() => string),
        isOpenCallback: (() => boolean) | undefined = undefined
    ): CmpPersistAlertObject {
        const obj = new CmpPersistAlertObject();

        if (typeof type === 'function') {
            obj.typeCallback = type;
        } else {
            obj.type = type;
        }

        if (typeof title === 'function') {
            obj.titleCallback = title;
        } else {
            obj.title = title;
        }

        if (typeof message === 'function') {
            obj.messageCallback = message;
        } else {
            obj.message = message;
        }

        if (isOpenCallback) {
            obj.isOpenCallback = isOpenCallback;
        }
        return obj;
    }

    public update(): {changed: boolean, alert: CmpPersistAlertObject} {
        let changed = false;
        if (this.typeCallback) {
            const newType = this.typeCallback();
            changed = changed || this.type !== newType;
            this.type = newType;
        }

        if (this.titleCallback) {
            const newTitle = this.titleCallback();
            changed = changed || this.title !== newTitle;
            this.title = newTitle;
        }

        if (this.messageCallback) {
            const newMessage = this.messageCallback();
            changed = changed || this.message !== newMessage;
            this.message = newMessage;
        }

        if (this.isOpenCallback) {
            const newIsOpen = this.isOpenCallback();
            changed = changed || this.isOpen !== newIsOpen;
            this.isOpen = newIsOpen;
        }

        const prevCssClass = this.cssClass;
        const prevIconCssClass = this.iconCssClass;
        switch (this.type) {
            case 'error':
                this.cssClass = 'alert alert-danger';
                this.iconCssClass = 'icon-delete-1';
                break;
            case 'info':
                this.cssClass = 'alert alert-info';
                this.iconCssClass = 'icon-information-circle';
                break;
            case 'warning':
                this.cssClass = 'alert alert-warning';
                this.iconCssClass = 'icon-alert-circle';
                break;
            case 'success':
            default:
                this.cssClass = 'alert alert-success';
                this.iconCssClass = 'icon-check-circle-1';
                break;
        }

        changed = changed || prevCssClass !== this.cssClass || prevIconCssClass !== this.iconCssClass;

        return {changed, alert: this};
    }

    public hide(): void {
        this.isOpen = false;
    }

    public show(): void {
        this.isOpen = true;
    }
}